import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import JSZip from "jszip";
import api from "../../../../api/api";
import { useAuth } from "../../../../context/AuthContext";
import logo from "../../../../image/logo.png";
import "./ViewBLdraft.css";
import Button from "../../../../components/Button";
import BackButton from "../../../../components/BackButton";

const ViewBLDraft = () => {
  const { id } = useParams();
  const [enquiry, setEnquiry] = useState(null);
  const [activeTab, setActiveTab] = useState("BL1");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAcceptSuccess, setShowAcceptSuccess] = useState(false);
  const [sendBLResponse, setSendBLResponse] = useState(null);
  const [showAcceptConfirm, setShowAcceptConfirm] = useState(false);
  const [showConfirmSales, setShowConfirmSales] = useState(false);
  const [isConfirmedSales, setIsConfirmedSales] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [accepting, setAccepting] = useState(false);
  const [downloadingExpress, setDownloadingExpress] = useState(false);
  const [downloadingRFS, setDownloadingRFS] = useState(false);
  const [downloadingSOB, setDownloadingSOB] = useState(false);
  const [downloadingOriginals, setDownloadingOriginals] = useState(false);
  const [downloadingNonNegotiable, setDownloadingNonNegotiable] = useState(false);
  const [blStamps, setBlStamps] = useState({
    containerStamps: [],
    descriptionStamps: [],
    measurementStamps: []
  });
  const [deliveryAgent, setDeliveryAgent] = useState("");
  const [acceptedPDFs, setAcceptedPDFs] = useState(null); // Store PDFs after BL acceptance
  const [blNumber, setBlNumber] = useState(""); // BL Number for MTD No. box
  const navigate = useNavigate();
  const { user } = useAuth();

  // Load stamps and delivery agent from localStorage
  useEffect(() => {
    const savedStamps = localStorage.getItem(`blStamps_${id}`);
    if (savedStamps) {
      try {
        setBlStamps(JSON.parse(savedStamps));
      } catch (e) {
        console.error("Error parsing stamps:", e);
      }
    }
    // Load delivery agent
    const savedDeliveryAgent = localStorage.getItem(`deliveryAgent_${id}`);
    if (savedDeliveryAgent) {
      setDeliveryAgent(savedDeliveryAgent);
    }
  }, [id]);

  const handleSendBL = () => {
    setShowConfirm(true);
  };

  const handleEditRequest = () => {
    navigate(`/my-bookings/edit-shipping-instructions/${id}`);
  };

  const handleConfirmSend = async () => {
    setSending(true);
    try {
      // Get Place of Issue from localStorage
      const savedPlaceOfIssue = localStorage.getItem(`placeOfIssue_${id}`) || "New Delhi";
      
      // Save BL number to database (increment counter and save BL_id)
      try {
        const saveBLResponse = await api.post(`/bl/save-bl-number/${id}`, { location: savedPlaceOfIssue });
        if (saveBLResponse.data.blNumber) {
          setBlNumber(saveBLResponse.data.blNumber);
          console.log("BL Number saved:", saveBLResponse.data.blNumber);
        }
      } catch (saveBLError) {
        console.error("Error saving BL number:", saveBLError);
        // Continue with sending BL even if save fails
      }
      
      // Get stamps from localStorage
      const savedStamps = localStorage.getItem(`blStamps_${id}`);
      const stamps = savedStamps ? JSON.parse(savedStamps) : { containerStamps: [], descriptionStamps: [], measurementStamps: [] };
      // Get delivery agent from localStorage
      const savedDeliveryAgent = localStorage.getItem(`deliveryAgent_${id}`) || "";
      
      await api.post("/si-admin/sendBL", {
        enq_id: id,
        whatsapp_number: enquiry?.whatsapp_number || "+917807785161",
        stamps: stamps,
        deliveryAgent: savedDeliveryAgent,
      });
      setShowConfirm(false);
      setShowSuccess(true);
    } catch (error) {
      console.error(error);
      alert("Failed to send BL");
    } finally {
      setSending(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate("/list-of-bl/admin");
  };

  const handleAcceptBL = () => {
    if (
      user?.user_role === "sales_rep" ||
      user?.user_role === "Admin" ||
      user?.user_role === "SuperAdmin"
    ) {
      setShowConfirmSales(true);
      setIsConfirmedSales(false);
    } else {
      setShowAcceptConfirm(true);
    }
  };

  const handleConfirmAcceptBL = async () => {
    setAccepting(true);
    try {
      const response = await api.post("/bl/acceptBL", { enq_id: id });
      setShowAcceptConfirm(false);
      setShowAcceptSuccess(true);
      // Store the PDF URLs for download
      if (response.data.pdfs) {
        setAcceptedPDFs(response.data.pdfs);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to accept BL");
    } finally {
      setAccepting(false);
    }
  };

  const handleConfirmAcceptBLSales = async () => {
    setAccepting(true);
    try {
      const response = await api.post("/bl/acceptBL", { enq_id: id });
      setShowConfirmSales(false);
      setShowAcceptSuccess(true);
      // Store the PDF URLs for download
      if (response.data.pdfs) {
        setAcceptedPDFs(response.data.pdfs);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to accept BL");
    } finally {
      setAccepting(false);
    }
  };

  // Helper function to download file to user's device
  const downloadFile = async (url, filename) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
      // Fallback: open in new tab
      window.open(url, '_blank');
    }
  };

  // Download all originals as ZIP file
  const downloadAllOriginals = async () => {
    if (!acceptedPDFs?.originals || acceptedPDFs.originals.length === 0) {
      alert("No originals available to download");
      return;
    }

    setDownloadingOriginals(true);
    try {
      console.log("Starting ZIP creation with", acceptedPDFs.originals.length, "files");

      // Create a new JSZip instance
      const zip = new JSZip();

      // Fetch all PDFs and add them to the ZIP
      let filesAdded = 0;
      for (let i = 0; i < acceptedPDFs.originals.length; i++) {
        const original = acceptedPDFs.originals[i];
        const filename = `BL_${original.name.replace(/\s+/g, '_')}_${id}.pdf`;

        console.log(`Fetching file ${i + 1}/${acceptedPDFs.originals.length}:`, original.url);

        try {
          // Use backend API proxy to download the file (avoids CORS issues with Azure)
          const response = await api.get(`/bl/download-bl-document/${original.id}`, {
            responseType: 'blob'
          });

          const blob = new Blob([response.data], { type: 'application/pdf' });
          console.log(`File ${i + 1} fetched successfully, size:`, blob.size);

          // Add to ZIP
          zip.file(filename, blob);
          filesAdded++;
        } catch (fetchError) {
          console.error(`Error fetching file ${i + 1}:`, fetchError);
          // Fallback: try opening in new tab
          try {
            window.open(original.url, '_blank');
          } catch (openError) {
            console.error(`Could not open file ${i + 1}:`, openError);
          }
        }
      }

      console.log(`Files added to ZIP: ${filesAdded}/${acceptedPDFs.originals.length}`);

      if (filesAdded === 0) {
        alert("No files could be downloaded. Please check if the files exist and you have permission to access them.");
        return;
      }

      console.log("Generating ZIP file...");

      // Generate and download the ZIP file
      const zipBlob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 6 }
      });

      console.log("ZIP file generated, size:", zipBlob.size);

      const downloadUrl = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `BL_Originals_${id}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      console.log("ZIP download initiated");
    } catch (error) {
      console.error("Error creating ZIP file:", error);
      alert(`Failed to download originals: ${error.message}`);
    } finally {
      setDownloadingOriginals(false);
    }
  };

  const handleCancelAcceptBLSales = () => {
    setShowConfirmSales(false);
    setIsConfirmedSales(false);
  };

  useEffect(() => {
    const fetchEnquiry = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        setEnquiry(response.data);
        
        // If BL_id already exists, use it
        if (response.data.BL_id && !response.data.BL_id.startsWith('BL' + id)) {
          setBlNumber(response.data.BL_id);
        } else {
          // If BL_id doesn't exist, fetch the preview BL number
          try {
            // Get location from localStorage or use the saved place_of_issue from DB
            const savedPlaceOfIssue = localStorage.getItem(`placeOfIssue_${id}`) || response.data.place_of_issue || "New Delhi";
            const previewResponse = await api.get(`/bl/generate-bl-number-preview/${id}?location=${savedPlaceOfIssue}`);
            if (previewResponse.data.blNumber && !previewResponse.data.isSaved) {
              setBlNumber(previewResponse.data.blNumber);
            }
          } catch (previewError) {
            console.error("Error fetching BL number preview:", previewError);
          }
        }
        
        // If BL is accepted, fetch the BL documents
        if (response.data.Status === "BL Accepted") {
          try {
            const docsResponse = await api.get(`/bl/bl-documents/${id}`);
            const docs = docsResponse.data;
            
            // Check document type to organize documents appropriately
            // Show Seaway button if document_type is 'Seaway' OR if Switch BL case has seaway docs
            const docType = response.data.document_type || '';
            const isSeawayBL = docType.trim().toLowerCase() === 'seaway';
            const isSwitchBLCase = response.data.switch_bl === "Yes" || response.data.document_type === "Switch BL";
            console.log('document_type:', response.data.document_type, 'isSeawayBL:', isSeawayBL);
            
            // Organize documents by type - include document ID for downloading via API proxy
            const originals = docs
              .filter(d => d.document_name.includes("Original"))
              .map(d => ({ name: d.document_name, url: d.url, id: d.id }));
            
            // Handle Seaway - for Switch BL there are multiple versions
            let seawayDocs = [];
            if (isSwitchBLCase) {
              seawayDocs = docs.filter(d => d.document_name.includes("Seaway - ")).map(d => ({ name: d.document_name, url: d.url, id: d.id }));
            } else {
              const seaway = docs.find(d => d.document_name === "Seaway");
              if (seaway) {
                seawayDocs = [{ name: seaway.document_name, url: seaway.url, id: seaway.id }];
              }
            }
            
            // Handle Non-Negotiable - single for normal, array for Switch BL
            // Use response.data.switch_bl with fallback to document_type for compatibility
            // isSwitchBLCase is already declared above
            let nonNegDocs = [];
            if (isSwitchBLCase) {
              // Switch BL: get both Non Negotiable - BL1 and Non Negotiable - BL2
              nonNegDocs = docs.filter(d => 
                d.document_name.includes("Non Negotiable - BL")
              ).map(d => ({ name: d.document_name, url: d.url, id: d.id }));
            } else {
              // Normal BL: get single Non Negotiable - use includes for flexibility
              const nonNeg = docs.find(d => d.document_name.includes("Non Negotiable"));
              if (nonNeg) {
                nonNegDocs = [{ name: nonNeg.document_name, url: nonNeg.url, id: nonNeg.id }];
              }
            }
            
            setAcceptedPDFs({
              originals,
              seaway: seawayDocs.length > 0 ? seawayDocs : null,
              nonNegotiable: nonNegDocs,
              isSeawayBL
            });
          } catch (docError) {
            console.error("Error fetching BL documents:", docError);
          }
        }
      } catch (err) {
        console.error("Failed to fetch enquiry:", err);
        setError("Enquiry not found or server error");
      } finally {
        setLoading(false);
      }
    };

    fetchEnquiry();
  }, [id]);

  if (loading) return <p>Loading BL Draft...</p>;
  if (error) return <p>{error}</p>;
  if (!enquiry) return <p>No data found</p>;

  const isSwitchBL = (enquiry?.switch_bl === "Yes" || enquiry?.document_type === "Switch BL");
  const display = (value, fallback = "") => value || fallback;
  
  // Helper function to format number of originals with word
  const formatNumberOfOriginals = (num) => {
    const numberWords = {
      1: 'One',
      2: 'Two',
      3: 'Three',
      4: 'Four',
      5: 'Five',
      6: 'Six',
      7: 'Seven',
      8: 'Eight',
      9: 'Nine',
      10: 'Ten'
    };
    const n = parseInt(num) || 3;
    const word = numberWords[n] || n.toString();
    return `${n} (${word})`;
  };

  return (
    <>
      <BackButton />
      <div
        className={`row align-items-center mb-3 ${enquiry.Status === "BL Draft Created" ? "justify-content-end" : "justify-content-between"} `}
      >
        {user &&
          (user.user_role === "Admin" || user.user_role === "SuperAdmin") && (
            <>
              {/* Send BL Draft Button */}
              {enquiry.Status !== "BL Draft Created" &&
                enquiry.Status !== "BL Accepted" && (
                  <div className="col-md-4 text-end">
                    <Button
                      text="Send BL Draft"
                      size="lg"
                      btncls="w-70"
                      onClick={handleSendBL}
                    />
                  </div>
                )}
 
             
              {/*new  */}
 
              {/* Dropdown Functionality */}
              {enquiry.Status === "BL Accepted" && (
                <div className="glassmorphism-action-panel d-flex justify-content-end p-0 mb-0 pe-2">
                  <div className="dropdown-container">
                    <button
                      className="fancy-static-btn dropdown-toggle d-flex justify-content-center"
                      style={{ minWidth: "180px" }}
                    >
                     Downloads BLs
                    </button>
 
                    <div className="dropdown-menu">
                      {/* RFS BL */}
                      <button
                        className="dropdown-item"
                        disabled={downloadingRFS}
                        onClick={async () => {
                          setDownloadingRFS(true);
                          try {
                            const response = await api.get(
                              `/bl/generate-rfs-bl/${id}`,
                              { responseType: "blob" },
                            );
                            const blob = new Blob([response.data], {
                              type: "application/pdf",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = `BL_RFS_${id}.pdf`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(link.href);
 
                            const enquiryResponse = await api.get(
                              `/enquiry/viewEnquiry/${id}`,
                            );
                            setEnquiry(enquiryResponse.data);
                          } catch (error) {
                            alert("Failed to generate RFS BL");
                          } finally {
                            setDownloadingRFS(false);
                          }
                        }}
                      >
                        {enquiry.rfs_bl_generated_by
                          ? "Download RFS BL"
                          : "Generate RFS BL"}
                        {downloadingRFS && (
                          <span className="loading-spinner"></span>
                        )}
                      </button>
 
                      {/* SOB BL */}
                      <button
                        className="dropdown-item"
                        disabled={downloadingSOB}
                        onClick={async () => {
                          setDownloadingSOB(true);
                          try {
                            const response = await api.get(
                              `/bl/generate-sob-bl/${id}`,
                              { responseType: "blob" },
                            );
                            // Check if response is ZIP or PDF
                            const contentType = response.headers['content-type'] || '';
                            const isZip = contentType.includes('application/zip');
                            const isPdf = contentType.includes('application/pdf');
                            
                            console.log('SOB BL download - Content-Type:', contentType);
                            
                            if (isZip) {
                              // Handle ZIP download for Switch BL
                              const blob = new Blob([response.data], { type: "application/zip" });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_SOB_SwitchBL_${id}.zip`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            } else if (isPdf) {
                              // Single PDF (non-switch)
                              const blob = new Blob([response.data], {
                                type: "application/pdf",
                              });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_SOB_${id}.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            } else {
                              // Fallback - treat as ZIP
                              const blob = new Blob([response.data], { type: "application/zip" });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_SOB_SwitchBL_${id}.zip`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            }
 
                            const enquiryResponse = await api.get(
                              `/enquiry/viewEnquiry/${id}`,
                            );
                            setEnquiry(enquiryResponse.data);
                          } catch (error) {
                            alert("Failed to generate SOB BL");
                          } finally {
                            setDownloadingSOB(false);
                          }
                        }}
                      >
                        {enquiry.sob_bl_generated_by
                          ? "Download SOB BL"
                          : "Generate SOB BL"}
                        {isSwitchBL && " (ZIP)"}
                        {downloadingSOB && (
                          <span className="loading-spinner"></span>
                        )}
                      </button>
 
                      {/* Express BL */}
                      <button
                        className="dropdown-item"
                        disabled={downloadingExpress}
                        onClick={async () => {
                          setDownloadingExpress(true);
                          try {
                            const response = await api.get(
                              `/bl/generate-express-bl/${id}`,
                              { responseType: "blob" },
                            );
                            // Check if response is ZIP or PDF
                            const contentType = response.headers['content-type'] || '';
                            const isZip = contentType.includes('application/zip');
                            const isPdf = contentType.includes('application/pdf');
                            
                            console.log('Express BL download - Content-Type:', contentType);
                            
                            if (isZip) {
                              // Handle ZIP download for Switch BL
                              const blob = new Blob([response.data], { type: "application/zip" });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_Express_SwitchBL_${id}.zip`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            } else if (isPdf) {
                              // Single PDF (non-switch)
                              const blob = new Blob([response.data], {
                                type: "application/pdf",
                              });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_Express_${id}.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            } else {
                              // If not PDF or ZIP, treat as ZIP (fallback for Switch BL)
                              console.log('Unknown content type, treating as ZIP');
                              const blob = new Blob([response.data], { type: "application/zip" });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_Express_SwitchBL_${id}.zip`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            }
 
                            const enquiryResponse = await api.get(
                              `/enquiry/viewEnquiry/${id}`,
                            );
                            setEnquiry(enquiryResponse.data);
                          } catch (error) {
                            alert("Failed to generate Express BL");
                          } finally {
                            setDownloadingExpress(false);
                          }
                        }}
                      >
                        {enquiry.express_bl_generated_by
                          ? "Download Express BL"
                          : "Generate Express BL"}
                        {isSwitchBL && " (ZIP)"}
                        {downloadingExpress && (
                          <span className="loading-spinner"></span>
                        )}
                      </button>
 
                      {/* Originals */}
                      {acceptedPDFs?.isSeawayBL ? (
                        <button
                          className="dropdown-item"
                          disabled={downloadingOriginals}
                          onClick={async () => {
                            // Handle Switch BL case with multiple seaway docs
                            const seawayDocs = acceptedPDFs.seaway;
                            if (!seawayDocs || seawayDocs.length === 0)
                              return alert("Seaway BL not available");
                            
                            setDownloadingOriginals(true);
                            try {
                              // For Switch BL, download all seaway docs as ZIP
                              if (isSwitchBL && seawayDocs.length > 1) {
                                const zip = require('jszip');
                                const zipObj = new zip();
                                for (const doc of seawayDocs) {
                                  const response = await api.get(
                                    `/bl/download-bl-document/${doc.id}`,
                                    { responseType: "blob" }
                                  );
                                  zipObj.file(doc.name.replace(/\s+/g, '_') + '.pdf', response.data);
                                }
                                const zipBlob = await zipObj.generateAsync({ type: "blob" });
                                const blob = new Blob([zipBlob], { type: "application/zip" });
                                const link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = `Seaway_SwitchBL_${id}.zip`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } else {
                                // Single seaway doc
                                const response = await api.get(
                                  `/bl/download-bl-document/${seawayDocs[0].id}`,
                                  { responseType: "blob" },
                                );
                                const blob = new Blob([response.data], {
                                  type: "application/pdf",
                                });
                                const link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = `BL_Seaway_${id}.pdf`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }
                            } finally {
                              setDownloadingOriginals(false);
                            }
                          }}
                        >
                          Download Seaway BL
                          {isSwitchBL && " (ZIP)"}
                          {downloadingOriginals && (
                            <span className="loading-spinner"></span>
                          )}
                        </button>
                      ) : (
                        <button
                          className="dropdown-item"
                          disabled={downloadingOriginals}
                          onClick={downloadAllOriginals}
                        >
                          Download Originals
                          {downloadingOriginals && (
                            <span className="loading-spinner"></span>
                          )}
                        </button>
                      )}
 
                      {/* Non-Negotiable */}
                      <button
                        className="dropdown-item"
                        disabled={downloadingNonNegotiable}
                        onClick={async () => {
                          const nonNegDocs = acceptedPDFs?.nonNegotiable;
                          
                          if (!nonNegDocs || nonNegDocs.length === 0)
                            return alert("Document not available");
                          
                          setDownloadingNonNegotiable(true);
                          try {
                            if (isSwitchBL && nonNegDocs.length > 1) {
                              // Download both Non-Negotiable as ZIP for Switch BL
                              const zip = new JSZip();
                              
                              for (const doc of nonNegDocs) {
                                const response = await api.get(
                                  `/bl/download-bl-document/${doc.id}`,
                                  { responseType: "blob" }
                                );
                                zip.file(doc.name.replace(/\s+/g, '_') + '.pdf', response.data);
                              }
                              
                              const zipBlob = await zip.generateAsync({ type: "blob" });
                              const blob = new Blob([zipBlob], { type: "application/zip" });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `Non_Negotiable_SwitchBL_${id}.zip`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            } else {
                              // Download single Non-Negotiable
                              const doc = nonNegDocs[0];
                              const response = await api.get(
                                `/bl/download-bl-document/${doc.id}`,
                                { responseType: "blob" }
                              );
                              const blob = new Blob([response.data], {
                                type: "application/pdf",
                              });
                              const link = document.createElement("a");
                              link.href = window.URL.createObjectURL(blob);
                              link.download = `BL_Non_Negotiable_${id}.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(link.href);
                            }
                          } finally {
                            setDownloadingNonNegotiable(false);
                          }
                        }}
                      >
                        Download Non-Negotiable
                        {isSwitchBL && " (ZIP)"}
                        {downloadingNonNegotiable && (
                          <span className="loading-spinner"></span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
 
        {/* Accept BL Button - For all users when Status='BL Draft Created' or 'BL Draft Pending' */}
        {user &&
          enquiry.Status !== "BL Accepted" &&
          (enquiry.Status === "BL Draft Created" ||
            enquiry.Status === "BL Draft Pending") && (
            <>
              <div className="col-auto">
                <Button
                  text={
                    accepting
                      ? "Accepting..."
                      : user?.user_role === "User"
                        ? "Accept"
                        : "Accept BL (Offline Approval)"
                  }
                  size="lg"
                  onClick={handleAcceptBL}
                  disabled={accepting}
                />
              </div>
              {(user.user_role === "User" ||
                user.user_role === "sales_rep" ||
                user.user_role === "Admin" ||
                user.user_role === "SuperAdmin") && (
                <div className="col-auto">
                  <span
                    title={
                      enquiry?.BLeditNo >= 1
                        ? "Sorry, you can make only 1 edit request"
                        : ""
                    }
                  >
                    <button
                      className="btn btn-primary btn-lg"
                      disabled={enquiry?.BLeditNo >= 1}
                      onClick={handleEditRequest}
                    >
                      Edit
                    </button>
                  </span>
                </div>
              )}
            </>
          )}
      </div>

      {isSwitchBL && (
        <div style={{ marginBottom: "20px", display: "flex", gap: "10px" }}>
          <button
            onClick={() => setActiveTab("BL1")}
            className={`btn ${activeTab === "BL1" ? "btn-primary" : "btn-outline-primary"}`}
            style={{ padding: "10px 20px" }}
          >
            BL1
          </button>
          <button
            onClick={() => setActiveTab("BL2")}
            className={`btn ${activeTab === "BL2" ? "btn-primary" : "btn-outline-primary"}`}
            style={{ padding: "10px 20px" }}
          >
            BL2
          </button>
        </div>
      )}

      <div className="bl-print-wrapper">
        <div className="print-page">
          <table
            className="bl-table top"
            border="1"
            cellSpacing="0"
            cellPadding="4"
          >
            <tbody>
              {/* ================= HEADER ================= */}
              <tr>
                <td
                  colSpan="2"
                  className="title text-center"
                  style={{ height: "25px" }}
                >
                  MULTIMODAL TRANSPORT DOCUMENT
                </td>
                <td colSpan="2" rowSpan="5" className="original-box">
                  <div className="row justify-content-center">
                    <div className="col-6"></div>
                    <div className="col-6">
                      {" "}
                      <p
                        className="mb-0 ms-3"
                        style={{
                          fontSize: "18px",
                        }}
                      >
                        {enquiry.Status === "BL Draft Created"
                          ? "BL Draft"
                          : enquiry.document_type?.toLowerCase() === 'seaway'
                            ? "SEAWAY"
                            : "ORIGINAL"}
                      </p>
                    </div>
                  </div>

                  <div className="emptyboxparent">
                    <b className="minwex">MTD No.</b>
                    <div
                      className="emptybox d-flex align-items-center text-start ps-1"
                      style={{ marginLeft: "6px" }}
                    >
                      {display(blNumber)}
                    </div>
                  </div>
                  <div className="emptyboxparent">
                    <b className="minw">Shipment Reference No.</b>
                    <div className="emptybox d-flex align-items-center text-start ps-1 bt-0">
                      {display(enquiry?.job_number || enquiry?.booking_id1)}
                    </div>
                  </div>
                  <div className="d-flex flex-column align-items-center text-center">
                    <img src={logo} alt="logo" className="logo" />
                    <div className="company-info">
                      <b className="company-name">
                        GFR LOGISTICS INDIA PVT. LTD.
                      </b>
                      B-201, 2nd Floor, Vikas Tower, Block-G
                      <br />
                      Community Centre, Opp. PVR, Vikas Puri
                      <br />
                      New Delhi - 110018
                      <p style={{ fontSize: "0.75rem", margin: 0 }}>
                        Email: <b>info@gfrlogistics.com</b> | Website:
                        <b>https://gfrlogistics.com</b>
                      </p>
                      <b> CIN:</b> U50120DL2023PTC411446
                      <br />
                      <b> Regn No.</b> MTO/DGS/4097/JUL/2028
                    </div>
                  </div>
                  <div className="legal-text">
                    Taken in Charge in apparently good condition, herein at the
                    place of receipt, for transport and delivery as mentioned
                    above, unless otherwise stated. The MTO, in accordance with
                    the provisions contained in the MTD, undertakes to perform
                    or to procure the performance of the multimodal transport
                    from the place at which the goods are taken in charge, to
                    the place designated for delivery and assumes the
                    responsibility for such transport.
                    <br />
                    <br />
                    One of the MTD(s) must be surrendered, duly endorsed in
                    exchange for the goods in witness where of the original MTD
                    all of this tenor and date have been signed in the number
                    indicated below one of which being accomplished the other(s)
                    to be void.
                  </div>
                </td>
              </tr>

              {/* ================= SHIPPER ================= */}
              <tr>
                <td colSpan="2" className="box h90">
                  <b>Shipper</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    <p style={{ maxWidth: "75%" }}>
                      {display(
                        isSwitchBL && activeTab === "BL2"
                          ? enquiry.second_shipper_name
                          : enquiry.first_shipper_name,
                      )}
                    </p>
                    <p style={{ maxWidth: "75%" }}>
                      {display(
                        isSwitchBL && activeTab === "BL2"
                          ? enquiry.second_shipper_address
                          : enquiry.first_shipper_address,
                      )}
                    </p>
                  </div>
                </td>
              </tr>

              {/* ================= CONSIGNEE ================= */}
              <tr>
                <td colSpan="2" className="box h90">
                  <b>Consignee (or Order)</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    <p style={{ maxWidth: "75%" }}>
                      {" "}
                      {display(
                        isSwitchBL && activeTab === "BL2"
                          ? enquiry.second_consignee_name
                          : enquiry.first_consignee_name,
                      )}
                    </p>
                    <p style={{ maxWidth: "75%" }}>
                      {display(
                        isSwitchBL && activeTab === "BL2"
                          ? enquiry.second_consignee_address
                          : enquiry.first_consignee_address,
                      )}
                    </p>
                  </div>
                </td>
              </tr>

              {/* ================= NOTIFY ================= */}
              <tr>
                <td colSpan="2" className="box h90">
                  <b>Notify Party</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    {display(enquiry.notify_party_1)}
                    <br />
                    {display(enquiry.notify_party_1_address)}
                  </div>
                  {enquiry.notify_party_2 && (
                    <div style={{ marginTop: "8px", fontWeight: "normal" }}>
                      {enquiry.notify_party_2}
                      <br />
                      {enquiry.notify_party_2_address}
                    </div>
                  )}
                </td>
              </tr>

              {/* ================= PLACES ================= */}
              <tr>
                <td style={{ height: "50px" }}>
                  <b>Place of receipt</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    {isSwitchBL && activeTab === "BL2" ? "" : display(enquiry.Placeof_Receipt)}
                  </div>
                </td>
                <td>
                  <b>Port of Loading</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    {display(
                      isSwitchBL && activeTab === "BL2"
                        ? enquiry.switch_at
                        : enquiry.pol
                    )}
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <b>Port of Discharge</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    {display(
                      isSwitchBL && activeTab === "BL2"
                        ? enquiry.pod
                        : isSwitchBL
                        ? enquiry.switch_at
                        : enquiry.pod
                    )}
                  </div>
                </td>
                <td style={{ height: "50px" }}>
                  <b>Place of Delivery</b>
                  <div style={{ marginTop: "6px", fontWeight: "normal" }}>
                    {display(
                      isSwitchBL && activeTab === "BL1"
                        ? enquiry.switch_at
                        : enquiry.Placeof_Delivery
                    )}
                  </div>
                </td>
                <td rowSpan="2" style={{ borderRight: 0 }}>
                  <b>Modes / Means of Transport</b>
                  <div style={{ fontWeight: "normal" }}>
                    {display(enquiry.mode_of_shipment)}
                  </div>
                </td>
                <td rowSpan="2" style={{ borderLeft: 0 }}>
                  <b>Route / Place of Transshipment (if any)</b>
                  <div style={{ fontWeight: "normal" }}>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  colSpan="2"
                  className="bt-0 bb-0 br-0"
                  style={{ height: "40px" }}
                >
                  <div className="d-flex align-items-center">
                    <p className="mb-0">Vessel & Voyage No.</p>
                    <p style={{ fontWeight: "normal" }} className="ms-4 mb-0">
                      {enquiry.vessel_name} {enquiry.voyage_number}
                    </p>
                  </div>
                </td>
              </tr>

              {/* ================= CARGO DETAILS ================= */}
              <tr style={{ borderBottom: 0 }}>
                <td colSpan="4" className="no-padding bb-0">
                  <table
                    className="inner-table noborder"
                    style={{ minHeight: "350px", tableLayout: "fixed", width: "100%" }}
                  >
                    <tbody>
                      <tr>
                        {/* Container & Seal Numbers */}
                        <td
                          style={{
                            height: "150px",
                            paddingLeft: "1px",
                            paddingRight: "6px",
                            verticalAlign: "top",
                            width: "18%",
                            maxWidth: "18%",
                            wordWrap: "break-word",
                          }}
                          className="bl-0 bt-0 bb-0"
                        >
                          <b>Container No(s)</b>
                          <div
                            style={{
                              marginTop: "1.5rem",
                              fontWeight: "normal",
                              fontSize: "0.8rem",
                            }}
                          >
                            {enquiry.containerDetails?.map((cont, idx) => {
                              const originalStr = cont.container_number || "";
                              const parts = originalStr.split(" ");
                              const agentIndex = parts.indexOf("Agent");
                              let cleanedContainerNumber = originalStr;
                              let agentSealInfo = "";
                              if (agentIndex !== -1) {
                                agentSealInfo = parts
                                  .slice(agentIndex)
                                  .join(" ");

                                cleanedContainerNumber = parts
                                  .slice(0, agentIndex)
                                  .join(" ");
                              }

                              return (
                                <div
                                  key={idx}
                                  style={{
                                    marginBottom: "15px",
                                    borderBottom: "1px solid #eee",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  {cleanedContainerNumber}
                                  {cont.container_type}
                                  <br />
                                  {cont.seal_number}
                                  <br />
                                  {agentSealInfo && (
                                    <span>{agentSealInfo}</span>
                                  )}
                                </div>
                              );
                            }) || "No Containers"}
                          </div>
                          {/* Container Stamps */}
                          {blStamps.containerStamps.length > 0 && (
                            <div style={{ marginTop: "20px", paddingTop: "5px" }}>
                              {blStamps.containerStamps.map((stamp, idx) => (
                                <div key={idx} style={{ fontSize: "0.7rem", fontWeight: "bold", marginBottom: "2px" }}>
                                  {stamp}
                                </div>
                              ))}
                            </div>
                          )}
                        </td>

                        {/* Marks & Numbers */}
                        <td
                          style={{
                            verticalAlign: "top",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            width: "18%",
                            maxWidth: "18%",
                            wordWrap: "break-word",
                          }}
                          className="bt-0 bl-0 bb-0"
                        >
                          <b>Marks & Numbers</b>
                          <div
                            style={{
                              fontWeight: "normal",
                              marginTop: "1.5rem",
                              maxWidth: "50%",
                            }}
                          >
                            {display(enquiry.marks_and_packages)}
                          </div>
                        </td>

                        {/* Description of Goods */}
                        <td
                          className="bt-0 bl-0 bb-0"
                          style={{ paddingLeft: "6px", paddingRight: "6px", width: "35%", maxWidth: "35%", wordWrap: "break-word", overflowWrap: "break-word", wordBreak: "break-all" }}
                        >
                          <div
                            // className="text-center"
                            style={{ minHeight: "50px" }}
                          >
                            <p className="mb-0">
                              <b>Number and kind of packages / Description of Goods</b>
                            </p>
                            <p className="mb-0">
                              <b>SAID TO CONTAIN</b>
                            </p>
                          </div>
                          <div className="containertext " style={{ wordWrap: "break-word", overflowWrap: "break-word", wordBreak: "break-all" }}>
                            <p style={{}} className="mb-0">
                              {display(enquiry.packaging_count)}{" "}
                              {display(enquiry.packaging_type)}
                            </p>
                            <p style={{ wordWrap: "break-word", overflowWrap: "break-word", wordBreak: "break-word", whiteSpace: "pre-wrap" }} className="mb-0">
                              {display(enquiry.general_description)}
                            </p>
                            {/* Description Stamps */}
                            {blStamps.descriptionStamps.length > 0 && (
                              <div style={{ marginTop: "10px", paddingTop: "5px" }}>
                                {blStamps.descriptionStamps.map((stamp, idx) => (
                                  <div key={idx} style={{ fontSize: "0.7rem", fontWeight: "bold", marginBottom: "2px" }}>
                                    {stamp}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Weight */}
                        <td
                          style={{
                            verticalAlign: "top",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            width: "17%",
                            maxWidth: "17%",
                            wordWrap: "break-word",
                          }}
                          className="bt-0 bl-0 bb-0"
                        >
                          <b>Gross Weight</b>
                          {(enquiry.shipment_segment === "FE" || enquiry.shipment_segment === "FI") && (
                            <><br/><b>SAID TO WEIGH</b></>
                          )}
                          {(enquiry.shipment_segment === "LE" || enquiry.shipment_segment === "LI") && (
                            <><br/><b>SAID TO WEIGH/MEASURE</b></>
                          )}
                          <div
                            style={{
                              marginTop: "1.5rem",
                              fontWeight: "normal",
                            }}
                          >
                            {display(enquiry.gross_weight)} KGS
                            <div
                              style={{ marginTop: "2rem", fontSize: "0.75rem" }}
                            >
                              <b style={{ fontWeight: "Normal" }}>
                                Net Weight:
                              </b>
                              <p style={{ fontSize: "0.75rem" }}>
                                {display(enquiry.net_weight)} KGS
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* Measurement */}
                        <td
                          style={{
                            textAlign: "end",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            verticalAlign: "top",
                            width: "12%",
                            maxWidth: "12%",
                            wordWrap: "break-word",
                          }}
                          className="bl-0 bb-0 bt-0"
                        >
                          <b>Measurement</b>
                          <div
                            style={{
                              marginTop: "1.5rem",
                              fontWeight: "normal",
                            }}
                          >
                            {display(enquiry.measurement)}
                            {/* Measurement Stamps */}
                            {blStamps.measurementStamps.length > 0 && (
                              <div style={{ marginTop: "10px", paddingTop: "5px", textAlign: "end" }}>
                                {blStamps.measurementStamps.map((stamp, idx) => (
                                  <div key={idx} style={{ fontSize: "0.7rem", fontWeight: "bold", marginBottom: "2px" }}>
                                    {stamp}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="4" className="bt-0">
                  <div className="freight-heading-container">
                    <b>Particular Above Furnished by Consignor / Consignee</b>
                  </div>
                </td>
              </tr>

              {/* ================= FREIGHT & FOOTER ================= */}
              <tr>
                <td className="br ps-1" colSpan="2" rowSpan="2">
                  <strong>Delivery Agent</strong>
                  <p className="fw-normal mb-0" style={{ margin: "5px 0", whiteSpace: "pre-line" }}>
                    {deliveryAgent || ""}
                  </p>
                </td>

                <td>
                  Freight Amount
                  <p className="fw-normal">
                    {enquiry.show_freightAmount
                      ? enquiry.freight_amount || "N/A"
                      : ""}
                  </p>
                </td>

                <td>
                  No. of Original Bills of Lading
                  <p className="fw-normal">
                    {formatNumberOfOriginals(enquiry.number_of_originals)}
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  Freight payable at
                  <p className="fw-normal">
                    {enquiry.freight_terms === "Prepaid"
                      ? "ORIGIN"
                      : "DESTINATION"}
                  </p>
                </td>

                <td>
                  Place and date of Issue
                  <p className="fw-normal">
                    {(isSwitchBL && activeTab === "BL2" 
                      ? (enquiry.switch_at || "") 
                      : (enquiry.place_of_issue || "New Delhi")).toUpperCase()},{" "}
                    {isSwitchBL && activeTab === "BL2" 
                      ? (enquiry.date_of_issue_bl2 
                          ? new Date(enquiry.date_of_issue_bl2).toLocaleDateString("en-GB")
                          : "")
                      : (enquiry.date_of_issue 
                          ? new Date(enquiry.date_of_issue).toLocaleDateString("en-GB")
                          : new Date(enquiry.CreatedAT).toLocaleDateString("en-GB"))}
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="w-100">
                  <p
                    className="mb-0 me-3 mt-2 fw-normal"
                    style={{
                      fontSize: "10px",
                      textAlign: "justify",
                      lineHeight: "16px",
                    }}
                  >
                    By accepting this Bill of lading shipper accepts and abide
                    by all terms, conditions clauses printed and stamped on the
                    face or reverse side of this Bill of lading. By accepting
                    this Bill of lading, the shipper accepts his responsibility
                    towards the carrier for payment of freight(in case of
                    freight collect shipments),Accrued Government, reshipment or
                    disposal costs(as the case may be)if the consignee fails to
                    take delivery of the cargo within 90 days from the date the
                    cargo reaches destination. For freight prepaid Bill of
                    Ladings, delivery of Cargo is subject to realization of
                    freight cheque .Demurrage / Detention charges at port of
                    destination payable by consignee as per lines tariff. The
                    carrier reserves the right to prepack the goods if the same
                    are not in seaworthy packing. The packing condition will be
                    certified by the local bonded warehouse or competent survey
                    or , and the shipper by virtue of accepting this bill of
                    lading accepts the liability towards the cost for the same.
                    For shipments where inland trucking is involved it is
                    mandatory on consignee to custom clear-the shipment at port
                    of discharge. In case of any discrepancy found in declared
                    weight & volume the carrier reserves the right to hold the
                    shipment & recover all charges as per the revised weight &
                    volume whichever is high from shipper or consignee.
                  </p>
                </td>
                <td colSpan="2" className="sign-box">
                  <p>For GFR LOGISTICS INDIA PRIVATE LIMITED</p>
                  <p className="mb-3 me-3 text-end sign">
                    Authorized Signatory
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p className="mb-0" style={{ width: "40%" }}>
            <span
              className="text-center mt-auto d-block"
              style={{ fontSize: "0.875rem" }}
            >
              Weight and Measurement if container not included
            </span>
            <span
              className="text-center d-block"
              style={{ fontSize: "0.875rem" }}
            >
              (TERMS & CONDITIONS ON BACK HEREOF)
            </span>
          </p>
          <table
            className="bl-table"
            // border="1"
            cellSpacing="0"
            cellPadding="4"
            style={{ marginTop: "2rem" }}
          >
            <div className="terms-container">
              <table className="terms-table">
                <thead>
                  <tr>
                    <th colSpan={3} className="terms-heading">
                      -------------------- Standard Conditions governing
                      Multimodal Transport Documents (MTD), issued in
                      accordance with Multimodal Transportation of Goods Act,
                      1993 [As placed on www.dgshipping.com /Shipping Notices/
                      MTO] --------------------------------------
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {/* COLUMN 1: Items 1 to 8 */}
                    <td className="terms-column">
                      <p>
                        <b>1. Definitions:-</b> (a) "Carrier" means a person who
                        is engaged in the business of transporting, for hire,
                        goods by road, rail, inland waterways or sea;
                        <br /> (b) "Consignee" means the person named as
                        consignee in the multimodal transport contract;
                        <br /> (c) "Consignment" means the goods entrusted to a
                        MTO for Multimodal transportation;
                        <br /> (d) "Consignor " means the person, named in the
                        multimodal transport contract as consignor, by whom or
                        on whose behalf, the goods covered by such contract are
                        entrusted to a MTO for multimodal transportation ;<br />
                        (e) "Delivery" means - <br /> • (i) In the case of a
                        negotiable MTD, delivering of the consignment to, or
                        placing the consignment at the disposal of, the
                        consignee or any other person entitled to receive it;{" "}
                        <br />• (ii) In the case of a non-negotiable MTD,
                        delivering of the consignment to, or placing the
                        consignment at the disposal of, the consignee or any
                        person authorized by the consignee to accept delivery of
                        the consignment on his behalf; <br />• (f) "Endorsement"
                        means the signing by the consignee, or the endorsee
                        after adding a direction on a negotiable MTD, to pass
                        the property in the goods mentioned in such document to
                        a specified person;
                        <br /> (g) "Goods" includes
                        <br /> (i) containers, pallets or similar articles of
                        transport used to consolidate goods; and <br />
                        (ii) animals;
                        <br /> (h) "Mode of transport" means carriage of goods
                        by road, rail, inland waterways or sea;
                        <br /> (i) 'Multimodal transportation" means carriage of
                        goods, by two or more modes of transport, from the place
                        of acceptance of the goods in India to a place of
                        delivery of the goods outside India;
                        <br /> (j) "Multimodal transport contract" means a
                        contract entered into by the consignor and the MTO for
                        multimodal transportation; <br />
                        (k) "Multimodal Transport Operator" (MTO) means any
                        person who
                        <br /> (i) concludes a multimodal transport contract on
                        his own behalf or through another person acting on his
                        behalf;
                        <br /> (ii) acts as principal and not as an agent,
                        either of the consignor or of the carrier participating
                        in the multimodal transportation, and who assumes
                        responsibility for the performance of the contract; and
                        <br /> (iii) is registered under sub-section <br />
                        (3) of section 4 of the Act.
                        <br /> (l) "Negotiable MTD" means a MTD which is <br />
                        (i) Made out to order or to bearer ; or <br />
                        (ii) Made out to order and is transferable by
                        endorsement ; or <br />
                        (iii) Made out to bearer and is transferable without
                        endorsement. <br />
                        (m) "Non-negotiable MTD" means a MTD, which indicates
                        only one named consignee;
                      </p>
                      <p>
                        <b>2. Applicability:-</b> The provision set out and
                        referred to in this MTD shall apply, if the transport as
                        described on the face of the document is by two or more
                        modes of transport from the place of acceptance of the
                        goods in India to a place of delivery of the goods
                        outside India.
                      </p>
                      <p>
                        <b>3. Effect of issuance of MTD:-</b> (1) The issuance
                        of the MTD confers and imposes, on all parties having or
                        acquiring hereafter an interest, the rights/ obligations
                        and defences set out in the conditions mentioned in this
                        document. <br />
                        (2) By the issuance of the MTD the MTO <br />
                        (a) Undertakes to perform, and/or in his own name to
                        procure performance of, the Multimodal transport
                        including all services which are necessary to such
                        transport, from the time of taking the goods in charge
                        to the time of delivery, and accepts responsibility for
                        such transport and such services to the extent set out
                        in these conditions; <br />
                        (b) accepts responsibility for the acts and omissions of
                        his agents or servants, when such agents or servants are
                        acting within the scope of their employment, as if such
                        acts and omissions were own; <br />
                        (c) accepts responsibility for the acts and omissions of
                        any other person, whose services he uses, for the
                        performance of the contract evidenced by this MTD;{" "}
                        <br />
                        (d) undertakes to perform, or to procure performance of,
                        all acts necessary to ensure delivery;
                        <br /> (e) assumes liability, to the extent set out in
                        these conditions, of loss of or damage to the goods,
                        occurring between the time of taking them into his
                        charge and the time of delivery, and undertakes to pay
                        compensation as set out in these conditions in respect
                        of such loss or damage; <br />
                        (f) assumes liability, to the extent set out in these
                        conditions, for delay in delivery of the goods and
                        undertakes to pay comp--ensation as set out in these
                        conditions.
                      </p>
                      <p>
                        <b>4. Negotiability and Title to the Goods:-</b>By
                        accepting the Multimodal Transportation Document, the
                        consignor and his transferees agree with the MTO that,
                        unless it is marked "non-negotiable", it shall
                        constitute title to the goods and the holder, by
                        endorsement of this MTD, shall be entitled to receive or
                        to transfer the goods mentioned in this MTD.
                      </p>
                      <p>
                        <b>5. Reservations:-</b> If the MTD contains particulars
                        concerning the general nature, leading marks, number of
                        packages or pieces, weight or quantity of the goods
                        which, the MTO or a person acting on his behalf knows,
                        or has reasonable grounds to suspect, do not accurately
                        represent the goods actually taken in charge, or if he
                        has no reasonable means of checking such particulars,
                        the MTO or a person acting on his behalf shall insert in
                        the MTD a reservation specifying these inaccuracies,
                        grounds of suspicion or the absence of reasonable means
                        of checking. If the MTO or a person acting on his behalf
                        fails to note on the MTD the apparent condition of the
                        goods, he is deemed to have noted on the MTD that the
                        goods were in apparent good condition.
                      </p>
                      <p>
                        <b>6. Evidentiary effect of the MTD:-</b> (1) The MTD
                        shall be, prima facie, evidence of the taking in charge,
                        by the MTO, of the goods as described therein; and{" "}
                        <br />
                        (2) Proof to the contrary by the MTO shall not be
                        admissible if the MTD is issued in negotiable form and
                        has been transferred to third party, including a
                        consignee, who has acted in good faith in reliance on
                        the description of goods therein.
                      </p>
                      <p>
                        <b>7. Guarantee by the consignor:-</b> (1) The consignor
                        shall be deemed to have guaranteed, to the MTO, the
                        accuracy at the time the goods were taken in charge by
                        the MTO, of particulars relating to the general nature
                        of the goods, their marks, number, weight and quantity
                        and, if applicable, to the dangerous character of the
                        goods, as furnished by him for insertion in the MTD.
                        <br /> (2) The consignor shall indemnify, the MTO,
                        against loss resulting from inaccuracies or inadequacies
                        of the particulars. The consignor shall remain liable
                        even if the MTD has been transferred by him. The right
                        of the MTO to such indemnity shall in no way limit his
                        liability under the Multimodal Transport Contract to any
                        person other then the consignor.
                      </p>
                      <p>
                        <b>8. Dangerous Goods:-</b> (1) The consignor shall make
                        or label dangerous goods in a suitable manner as "
                        dangerous goods" <br />
                        (2) Where the consignor hands over dangerous goods to
                        the MTO or any person acting on his behalf, the
                        consignor shall inform him of the dangerous character of
                        the goods and, if necessary, the precautions to be
                        taken. If the consignor fails to do so and the MTO does
                        not otherwise have knowledge of their dangerous
                        character then: <br />
                        (a) The consignor shall be liable, to the MTO, for all
                        loss resulting from the shipment of such goods; and
                        <br /> (b) The goods may at any time be unloaded,
                        destroyed or rendered innocuous, as the circumstances
                        may require, without payment of compensation
                        <br /> (3) The above provisions may not be invoked by
                        any person if during the Multimodal Transport he has
                        taken the goods in his charge with knowledge of their
                        dangerous character. <br />
                        (4) If, in cases where the provisions
                        <br /> (2) (b) refereed to above do not apply or may not
                        be invoked, dangerous goods become an actual danger to
                        life or property they may be unloaded, destroyed or
                        rendered innocuous, as the circumstances may require,
                        without payment of compensation, except where there is
                        an obligation to contribute in general average or where
                        the MTO is liable, in accordance with the provisions of
                        relevant conditions
                      </p>
                    </td>

                    {/* COLUMN 2: Items 9 to 15 */}
                    <td className="terms-column">
                      <p>
                        <b>9. Period of responsibility:-</b> (1) The
                        responsibility of the MTO for the goods covers the
                        period from the time he takes the goods in his charge to
                        the time of their delivery. For the purpose of this
                        responsibility, the MTO is deemed to be in charge of the
                        goods <br />
                        (a) from the time he has taken over the goods from:{" "}
                        <br />
                        (i) the consignor or a person acting on his behalf; or
                        <br /> (ii) an authority or other third party to whom,
                        pursuant to law or regulations applicable at the place
                        of taking charge, the goods must be handed over for
                        transport; <br />
                        (b) until the time he has delivered the goods: <br />
                        (i) by handing them over to the consigner; or <br />
                        (ii) by placing them at the disposal of the consignee,
                        in accordance with the Multimodal Transport Contract or
                        with the law or with the usage of the particulars trade
                        applicable at the place of delivery; or <br />
                        (iii) by handing over the goods to an authority or other
                        third party to whom, pursuant to law or recognitions
                        applicable at the place of delivery, the goods must be
                        handed over. <br />
                        (2) Reference to the MTO in this regard shall include
                        his servants or agents or any other person of whose
                        services be makes use of for performance of the
                        Multimodal Transport Contract, and reference to the
                        consignor or consignee shall include their servants or
                        agents
                      </p>
                      <p>
                        <b>10. Basis of Liability:-</b> (1) The MTO shall be
                        liable, for loss resulting from loss of or damage to the
                        goods, delay in delivery and any consequential loss or
                        damage arising from such delay, if the occurrence which
                        caused such loss, damage or delay in delivery, took
                        place while the goods were in his charge, unless the MTO
                        proves that he, his servants or agents, or any other
                        person whose services he uses for the performance of the
                        contract evidenced by this MTD, took all measures that
                        could reasonably be required to avoid the occurrence and
                        its consequences.
                        <br /> (2) Where fault or neglect on the part of MTO,
                        his servants or agents, or any other person whose
                        services he uses for the performance of the contract
                        evidenced by this MTD, combines with another cause to
                        produce loss or damage or delay in delivery, the MTO
                        shall be liable only to the extent that the loss, damage
                        or delay in delivery which is attributable to such fault
                        or neglect, provided that the MTO proves the part of the
                        loss, damage or delay in delivery not attributable there
                        to. <br />
                        (3) Delay in delivery occurs when the goods have not
                        been delivered within the time expressly agreed upon or
                        in the absence of such agreement, within reasonable time
                        required by a diligent MTO, having regard to the
                        circumstances of the case to effect the delivery of
                        goods.
                        <br /> (4) If the goods have not been delivered within
                        ninety consecutive days following the date of delivery
                        expressly agreed upon, the claimant may treat the goods
                        as lost.
                      </p>
                      <p>
                        <b>
                          11. Liability for loss or damage when the stage of
                          Transport where the loss or damage occurred is not
                          known :-
                        </b>
                        (1) When the MTO is liable to pay compensation in
                        respect of loss of or damage to the goods, occurring
                        between the time of taking them into his charge and the
                        time of delivery, and the stage of Transport where the
                        loss or damage occurred is not known: <br />
                        (a) Such compensation shall be calculated by reference
                        to the value of such goods at the place and time they
                        are delivered to the consignee or at the place and time
                        when, in accordance with the contract of the Multimodal
                        Transport, they should have been so delivered. <br />
                        (b) The value of goods shall be determined according to
                        the current commodity exchange price or, if there is not
                        such price, according to the current market price, or if
                        there is no commodity exchange price or current market
                        price, by reference to the normal value of goods of the
                        same kind and quality; However, the MTO shall not, is
                        any case, be liable for an amount greater than the
                        actual loss to the person entitled to make the claim.{" "}
                        <br />
                        (2) Where a MTO becomes liable for any loss of, or
                        damage to, any consignment, the nature and value whereof
                        have not been declared by the consignor before such
                        consignment has been taken in charge by the MTO and the
                        stage of transport at which such loss or damage occurred
                        is not known, then the liability of the MTO to pay
                        compensation shall not exceed two Special Drawing Rights
                        per kilogram of the gross weight of the consignment lost
                        or damaged or 666.67 Special Drawing Rights per package
                        or unit lost or damaged, whichever is higher. <br />
                        (3) Notwithstanding anything contained above if the
                        multimodal transportation does not, according to the
                        multimodal transport contract, include carriage of goods
                        by sea or by inland waterways, the liability of the MTO
                        shall be limited to an amount not exceeding 8.33 Special
                        Drawing Rights per kilogram of the gross weight of the
                        goods lost or damaged.
                      </p>
                      <p>
                        <b>
                          12. Liability of loss or damage, when the stage of the
                          transport where the loss or damage occurred is known
                          :-
                        </b>{" "}
                        (1) When the MTO is liable to pay compensation in
                        respect of loss or damage to the goods, occurring
                        between the time of taking them into his charge and the
                        time of delivery, and the stage of the transport where
                        such loss or damage occurred is known, the liability of
                        the MTO in respect of such loss or damage shall be
                        determined by the applicable Indian Law if the loss or
                        damage occurs in India, or by the provisions of the
                        applicable law of the country where the loss or damage
                        occurred, as the case may be. Provisions of the Indian
                        Law or the applicable law outside India <br />
                        (a) cannot be departed from by private contract to the
                        detriment of the claimant, and <br />
                        (b) would have applied if the claimant had made a
                        separate and direct contract with the MTO in respect of
                        the particular stage of transport where the loss or
                        damage occurred. <br />
                        (2) Without prejudice to the provisions contained in
                        Para 3 (2) <br />
                        (b) and <br />
                        (c) mentioned in this document when, under the provision
                        of condition <br />
                        (1) mentioned above, the liability of the MTO shall be
                        determined by the provisions of the Law referred to in
                        condition <br />
                        (1) above, the liability shall be determined as though
                        the MTO was a carrier referred to in such law. However,
                        the MTO shall not be exonerated from liability, where
                        the loss or damage is caused or contributed to by the
                        acts or omissions of the MTO in his capacity as such, or
                        his servants or agents when acting in such capacity and
                        not in the performance of the carriage.
                      </p>
                      <p>
                        <b>
                          13. Defence and limits for the MTO and his servants:-
                        </b>
                        (1) The defences and limits of liability provided for in
                        this MTD shall apply, in action against the MTO, in
                        respect of loss resulting from loss of or damage to
                        goods; delay in delivery and any consequential loss or
                        damage arising from such delay. <br />
                        (2) If any action in respect of loss resulting from loss
                        of, or damage to, the goods or from delay in delivery is
                        brought against the servant or agent of the MTO, if such
                        servant or agent proves that he acted within the scope
                        of his employment, or against any other person of whose
                        service he makes use for the performance of the
                        Multimodal Transport Contract, if such other person
                        proves that he acted within the performance of the
                        contract, the servant or agent or such other person
                        shall be entitled to avail himself of the defences and
                        limits of liability which the MTO is entitled to invoke
                        under this MTD. <br />
                        (3) Except as provided for liability for delay, as
                        mentioned below, the aggregate of the amounts
                        receivable, from the MTO and from a servant or agent or
                        any other person of whose services he make use of, for
                        the performance of the Multimodal Transport Contract,
                        shall not exceed the limits of liability provided for in
                        this MTD.
                      </p>
                      <p>
                        <b>14. Liability for delay:-</b> The liability of the
                        MTO, for loss resulting from delay in delivery as per
                        condition10 above, shall be limited to an amount
                        equivalent to the freight payable for the goods delayed,
                        but not exceeding the total freight payable under the
                        Multimodal Transport Contract.
                      </p>
                      <p>
                        <b>15. Loss of the right to limit liability:-</b> (1)
                        The limits of liability established in conditions 11,12
                        and 14 above, shall not apply if it is proved that the
                        loss, damage or delay in delivery resulted from an act
                        or omission of the MTO (or his servants or agents or any
                        other person of whose services he makes use for the
                        performance of Multimodal Transport Contract), done,
                        with the intent to cause such loss, damage or delay in
                        delivery, or recklessly and with knowledge that such
                        loss, damage or delay would probably result. <br />
                        (2) Notwithstanding the provisions 13(2) above, if it is
                        proved that the loss, damage or delay in delivery,
                        resulted from an act or omission of a servant or agent
                        (or any person of whose services the MTO makes use, for
                        the performance of the Multimodal Transport Contract),
                        done, with the intent to cause loss, damage or delay in
                        delivery, or recklessly and with knowledge that such
                        loss, damage or delay in delivery would probably result,
                        the servant or agent shall not be entitled to the
                        benefit of limitation of liability provided for in these
                        conditions
                      </p>
                    </td>

                    {/* COLUMN 3: Items 16 to 26 */}
                    <td className="terms-column">
                      <p>
                        <b>16. Delivery / non-delivery:-</b>(1) If the goods are
                        not taken delivery of by the consignee within a
                        reasonable time, after the MTO has called upon him to
                        take delivery, the MTO shall be at liberty to put the
                        goods in safe custody on behalf of the consignee at the
                        consignee's risk and expense, or to place the goods at
                        the disposal of the consignee in accordance with the
                        Multimodal Transport Contract or with the law, or with
                        the usage of the particular trade applicable at the
                        place of delivery. <br />
                        (2) The MTO shall be discharged from his obligation to
                        deliver the goods if, where a negotiable MTD has been
                        issued, in a set of more than one original, he, or a
                        person acting on his behalf, has in good faith delivered
                        the goods against surrender of one of such originals.
                      </p>
                      <p>
                        <b>17. Notice of loss, damage or delay:-</b> (1) Unless
                        notice of loss or damage, specifying the general nature
                        of such loss or damage is given in writing by the
                        consignee to the MTO at the time of taking over the
                        goods, such handing over is prima facie evidence of the
                        delivery by MTO of the goods as described in the MTD{" "}
                        <br />
                        (2) Where the loss of or damage is not apparent, the
                        provisions of condition
                        <br /> (1) referred to above apply correspondingly, if
                        notice in writing is not given within six consecutive
                        days after the day when the goods were handed over to
                        the consignee. <br />
                        (3) If the state of the goods at the time they were
                        handed over to the consignee, has been the subject of a
                        joint survey or inspection by the parties or their
                        representatives at the place of delivery, notice in
                        writing need not be given, of loss or damage ascertained
                        during such survey or inspection.
                        <br /> (4) In the case of any actual or apprehended loss
                        or damage, the MTO and the consignee shall give all
                        reasonable facilities to each other for inspecting and
                        tallying the goods. <br />
                        (5) If any of the notice periods provided for in
                        condition <br />
                        (2) and (4) referred to above, terminates on a public
                        holiday at the place of delivery, such periods shall be
                        extended up to the next working day. <br />
                        (6) Notice given to a person acting on behalf of the MTO
                        including any person of whose services he makes use at
                        the place of delivery, shall be deemed to have given to
                        the MTO.
                      </p>
                      <p>
                        <b>18. Freight and charges:-</b> (1) Freight shall be
                        deemed earned, on receipt of goods by MTO and shall be
                        paid for, in any event. <br />
                        (2) For the purpose of verifying the freight basis, the
                        MTO reserves the right, to have the contents of the
                        containers, trailers or similar articles of transport
                        inspected, in order to ascertain the weight,
                        measurement, value or nature of the goods.
                        <br /> (3) All dues, taxes and the charges levied on the
                        goods and other expenses in connection therewith, shall
                        be paid by the consignor or the consignee or the holder
                        of MTD or the owner of the goods.
                      </p>
                      <p>
                        <b>19. Containers etc.:-</b> (1) Goods may be stowed by
                        the MTO by means of containers, trailers, transportable
                        tanks, flats, pallets or similar articles of transport
                        used to consolidate goods and these articles of
                        transport may be stowed under or on deck. <br />
                        (2) If a container has not been filled, packed or stowed
                        by the MTO, the MTO shall not be liable for any loss of,
                        or damage to, its contents and the consignor shall cover
                        any loss of expense incurred by the MTO, if such loss,
                        damage or expense has been caused by ; <br />
                        (a) negligent filling, packing or stowing of the
                        containers; or
                        <br /> (b) the contents being unsuitable for carriage in
                        container; or <br />
                        (c) the unsuitability or defective condition of the
                        container, unless the container has been supplied by the
                        MTO and the unsuitable or defective condition would not
                        have been apparent upon reasonable inspection at, or
                        prior to, the time when the container was filled, packed
                        and stowed. The provisions of this condition also apply
                        with respect to trailers, transportable tanks, flats and
                        pallets, which have not been filled, packed or stowed by
                        the MTO. <br />
                        (3) The MTO does not accept liability for the
                        functioning of reefer equipment or trailers supplied by
                        the consignor. <br />
                        (4) If, by order of the authorities of any place, the
                        goods have to be unpacked from their containers to be
                        inspected, the MTO shall not be liable for the loss or
                        damage incurred during unpacking, inspection or
                        re-packing. The MTO shall be entitled to recover the
                        cost of unpacking, inspection and repacking from the
                        consignor / consignee.
                      </p>
                      <p>
                        <b>20. Hindrances etc. affecting performance :- </b> The
                        MTO shall use reasonable endeavors to complete the
                        transport and to deliver the goods at the place designed
                        for delivery.
                      </p>
                      <p>
                        <b>21. Lien:-</b>The MTO shall have a lien on the goods,
                        for any amount due, under this Multimodal Transport
                        Contract and for the costs of recovering the same, and
                        may enforce such lien in any reasonable manner.
                      </p>
                      <p>
                        <b>22. Limitation of action:-</b> Any action relating to
                        Multimodal Transport under these conditions, shall be
                        timebarred if judicial proceedings have not been
                        instituted within a period of nine months after: <br />
                        (1) the date of delivery of the goods, or <br />
                        (2) the date when the goods should have been delivered,
                        or <br />
                        (3) the date, on and from which, the party entitled to
                        receive has the right to treat the goods as lost.
                      </p>
                      <p>
                        <b>23. Jurisdiction:-</b> (1) In judicial proceedings
                        relating to the contract for MTD under these conditions,
                        the plaintiff, at his option, may institute an action in
                        court, which, according to the law of the country where
                        the court is situated, is competent, and within the
                        jurisdiction of which is situated one of the following
                        places: <br />
                        (a) the principal place of business or, in the absence
                        thereof, the habitual residence of the defendant; or{" "}
                        <br />
                        (b) the place where the Multimodal Transport Contract
                        was made, provided that the defendant has there a place
                        of business, branch or agency at such place; or <br />
                        (c) the place of taking charge of the goods for
                        Multimodal Transportation or the place of delivery there
                        of; or <br />
                        (d) any other place specified for that purpose in the
                        Multimodal Transport Contract and evidenced in the MTD
                      </p>
                      <p>
                        <b>24. General Average:-</b> The consignor or consignee,
                        the holder of the MTD, the receiver and the owner of the
                        goods, shall indemnify MTO in respect of any claims of
                        the general average nature, which may be made on him and
                        shall provide such security as may be required by the
                        MTO in this connection
                      </p>
                      <p>
                        <b>25. Arbitration:-</b> The contract evidenced hereby or
                        contained herein shall be governed by and construed
                        according to Indian laws. Any difference of opinion or
                        dispute thereunder can be settled by arbitration in India
                        or a place mutually agreed with each party appointing an
                        arbitrator.
                      </p>
                      <p>
                        <b>26. Clause on Matters Affecting Performance:-</b> If at
                        any time Carriage is or is likely to be affected by any
                        hindrance, risk, danger, delay, difficulty or disadvantage
                        of whatsoever kind and howsoever arising which cannot be
                        avoided by the exercise of reasonable endeavours (even
                        though the circumstances giving rise to such hindrance,
                        risk, danger, delay, difficulty or disadvantage existed at
                        the time this contract was entered into or the Goods were
                        received for Carriage) the Multimodal Transport Operator
                        may at his sole discretion and without notice to the
                        Consignor/Consignee and whether or not the Carriage is
                        commenced either:
                        <br />
                        (a) Carry the Goods to the contracted Port of Discharge or
                        Place of Delivery, whichever applicable, by an alternative
                        route to that indicated in this Multimodal Transport
                        Document or that which is usual for Goods consigned to that
                        Port of Discharge or Place of Delivery. If the Multimodal
                        Transport Operator elects to invoke the terms of this
                        clause 26 then, he shall be entitled to charge such
                        additional Freight as the Multimodal Transport Operator may
                        determine; or
                        <br />
                        (b) Suspend the Carriage of the Goods and store them ashore
                        or afloat upon the Terms and Conditions of this Multimodal
                        Transport Document and endeavour to forward them as soon as
                        possible, but the Multimodal Transport Operator makes no
                        representations as to the maximum period of suspension. If
                        the Multimodal Transport Operator elects to invoke the
                        terms of this clause 26(b) then, notwithstanding the
                        provisions of clause 26 hereof, he shall be entitled to
                        charge such additional Freight and Costs as the Multimodal
                        Transport Operator may determine; or
                        <br />
                        (c) Abandon the Carriage of the Goods and place them at the
                        Consignor/Consignee's disposal at any place or port which
                        the Multimodal Transport Operator may deem safe and
                        convenient, whereupon the responsibility of the Multimodal
                        Transport Operator in respect of such Goods shall cease.
                        The Multimodal Transport Operator shall nevertheless be
                        entitled to full Freight on the Goods received for the
                        Carriage, and the Merchant shall pay any additional costs
                        incurred by reason of the abandonment of the Goods. If the
                        Multimodal Transport Operator elects to use an alternative
                        route under clause 26(a) or to suspend the Carriage under
                        clause 26(b) this shall not prejudice his right
                        subsequently to abandon the Carriage.
                        <br />
                        (d) The Multimodal Transport Operator shall not be liable
                        to the Consignor/Consignee for any loss, damages and/or
                        consequential losses if its performance is prevented by
                        reason of any incident of Force Majeure, including without
                        limitation to war, civil commotion, port congestion, fire,
                        flood, storm, inclement weather, earthquake, natural
                        disaster or any act of God, governmental act or decree or
                        any other matter or circumstances beyond the reasonable
                        control of the Multimodal Transport Operator.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>

      {/* Confirmation Modal */}
      <Modal
        show={showConfirm}
        onHide={() => !sending && setShowConfirm(false)}
      >
        <Modal.Header closeButton={!sending}>
          <Modal.Title>Confirm Send BL Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to send the BL Draft to the customer?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowConfirm(false)}
            disabled={sending}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirmSend}
            disabled={sending}
          >
            {sending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Sending...
              </>
            ) : (
              "Send"
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose}>
        <Modal.Header closeButton>
          <Modal.Title>BL Draft Sent</Modal.Title>
        </Modal.Header>
        <Modal.Body>The BL Draft has been sent successfully!</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleSuccessClose}>
            OK
          </button>
        </Modal.Footer>
      </Modal>

      {/* Accept Confirmation Modal */}
      <Modal
        show={showAcceptConfirm}
        onHide={() => !accepting && setShowAcceptConfirm(false)}
      >
        <Modal.Header closeButton={!accepting}>
          <Modal.Title>Confirm Accept BL</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to accept the BL Draft?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowAcceptConfirm(false)}
            disabled={accepting}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirmAcceptBL}
            disabled={accepting}
          >
            {accepting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Accepting...
              </>
            ) : (
              "Accept"
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Accept Success Modal */}
      <Modal
        show={showAcceptSuccess}
        onHide={() => setShowAcceptSuccess(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>BL Accepted</Modal.Title>
        </Modal.Header>
        <Modal.Body>The BL has been accepted successfully!</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowAcceptSuccess(false);
              navigate("/list-of-bl/admin");
            }}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal for Sales Rep */}
      {showConfirmSales && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Confirm Offline Approval Acceptance
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCancelAcceptBLSales}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to accept the BL Draft on behalf of the
                  customer?
                </p>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="confirmOfflineBLCheckbox"
                    checked={isConfirmedSales}
                    onChange={(e) => setIsConfirmedSales(e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="confirmOfflineBLCheckbox"
                  >
                    I confirm that the client has given offline approval to me.
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancelAcceptBLSales}
                  disabled={accepting}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmAcceptBLSales}
                  disabled={!isConfirmedSales || accepting}
                >
                  {accepting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Accepting...
                    </>
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop for Sales Modal */}
      {showConfirmSales && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default ViewBLDraft;


